import React from "react";

import axios from "./axios";
import requests from "./requests";
import { useEffect, useState } from "react";
import "./Banner.css";
const Banner = () => {
  const [movie, setMovie] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      const request = await axios.get(requests.fetchNetflixOriginals);
      // setMovie(request);
      setMovie(
        request.data.results[
          Math.floor(Math.random() * request.data.results.length)
        ]
      );
      return request;
    }
    fetchData();
  }, []);

  const truncate = (str, n) =>
    str.length > n ? str.substr(0, n) + "..." : str;
  console.log(movie);
  return (
    <>
      <div
        style={{
          backgroundImage: `url(https://image.tmdb.org/t/p/original/${movie?.backdrop_path})`,
          backgroundPosition: "center ",
          backgroundSize: "cover",
        }}
        className="banner"
      >
        <div className="banner__contents">
          <h1 className="banner__title">
            {movie?.name || movie?.title || movie?.original_name}
          </h1>

          <div className="banner__buttons">
            <button className="banner__button">
              Play
            </button>
            <button className="banner__button">
              
              My List
            </button>
          </div>
          <h1 className="banner__description">{truncate(`${movie?.overview}`, 150)}</h1>
        </div>
        <div className="banner__fadeBottom"> </div>
      </div>
    </>
  );
};

export default Banner;
 